export default "__VITE_ASSET__BMzg_bqK__"